import { createAction } from 'typesafe-actions';

export const push = createAction('router/PUSH')<string>();
export const replace = createAction('router/REPLACE')<string>();
export const goBack = createAction('router/GO_BACK')<void>();
export const goForward = createAction('router/GO_FORWARD')<void>();
